/**
 * Hero Scramble Animation
 * Scrambles the homepage hero H1 ("OFF PISTE"), the hero description paragraph,
 * and the hero call-to-action buttons on load — a "decrypting" load-in effect
 * using GSAP's ScrambleTextPlugin.
 */

(function () {
  'use strict';

  var SCRAMBLE_CHARS = '01XO!@#$%^&*'; // tech/digital character set

  // Wait for GSAP to be loaded
  function waitForGSAP(callback, attempts) {
    attempts = attempts || 0;
    if (typeof gsap !== 'undefined' && typeof gsap.registerPlugin === 'function') {
      callback();
    } else if (attempts < 50) {
      // Give up after ~5s so a blocked/absent CDN can't poll forever.
      setTimeout(function () { waitForGSAP(callback, attempts + 1); }, 100);
    }
  }

  function scramble(el, opts) {
    opts = opts || {};
    var raw = el.textContent;
    var originalText = opts.trim === false ? raw : raw.trim();
    if (!originalText) return;
    el.style.opacity = '1';

    // Lock the element's size to its final (pre-scramble) dimensions so the
    // scrambled characters — which are wider/narrower than the real text in a
    // proportional font — can't reflow it (extra/fewer lines) or make a
    // content-sized element (e.g. a button) jitter horizontally. Released on
    // completion so the element stays responsive to viewport changes after.
    var lockH = opts.lockHeight !== false; // default on
    var lockW = opts.lockWidth === true; // opt-in (buttons)
    var prev = {
      height: el.style.height,
      width: el.style.width,
      overflow: el.style.overflow,
      whiteSpace: el.style.whiteSpace
    };
    var h = lockH ? el.offsetHeight : 0;
    var w = lockW ? el.offsetWidth : 0;
    if (h) {
      el.style.height = h + 'px';
      el.style.overflow = 'hidden';
    }
    if (w) {
      el.style.width = w + 'px';
      el.style.overflow = 'hidden';
      el.style.whiteSpace = 'nowrap';
    }

    gsap.to(el, {
      duration: opts.duration,
      scrambleText: {
        text: originalText,
        chars: SCRAMBLE_CHARS,
        revealDelay: opts.revealDelay,
        speed: opts.speed,
        tweenLength: false,
        rightToLeft: false
      },
      delay: opts.delay,
      ease: 'power2.out',
      onComplete: function () {
        if (h) {
          el.style.height = prev.height;
        }
        if (w) {
          el.style.width = prev.width;
          el.style.whiteSpace = prev.whiteSpace;
        }
        if (h || w) {
          el.style.overflow = prev.overflow;
        }
        if (typeof opts.onComplete === 'function') {
          opts.onComplete();
        }
      }
    });
  }

  function initHeroScrambleAnimation() {
    if (typeof ScrambleTextPlugin === 'undefined') {
      console.error('Hero Scramble: ScrambleTextPlugin not found!');
      return;
    }
    gsap.registerPlugin(ScrambleTextPlugin);

    // 1) The display headline (e.g. "OFF PISTE") — the hero's own top-level text
    //    block. Selected by position rather than by tag: the headline is an <h2>
    //    and the page's <h1> is the description's lead sentence below, so an
    //    h1-based selector would scramble the wrong element.
    var heroH1s = document.querySelectorAll('.hero__content-wrapper > [data-layer] > .text-block > *');
    heroH1s.forEach(function (h1, index) {
      scramble(h1, { duration: 1, revealDelay: 0.2, speed: 0.8, delay: index * 0.15 });
    });

    // 2) Description lines — same effect, starting at the same time as the heading.
    //    `> *` not `p`: the first line is the page's <h1>, the call-out below it a <p>.
    var baseDelay = 0;
    var heroDescs = document.querySelectorAll('.hero__content-wrapper .group-block .text-block > *');
    heroDescs.forEach(function (p, index) {
      scramble(p, { duration: 1.1, revealDelay: 0.1, speed: 0.7, delay: baseDelay + index * 0.1 });
    });

    // 3) Hero call-to-action buttons ("Explore the tech", "Shop apparel") —
    //    start together with the heading. Lock width so the button doesn't
    //    jitter as the scrambled label changes size.
    var heroButtons = document.querySelectorAll(
      '.hero__content-wrapper a.button, .hero__content-wrapper a.button-secondary'
    );
    heroButtons.forEach(function (btn) {
      scramble(btn, { duration: 1, revealDelay: 0.15, speed: 0.8, delay: 0, lockWidth: true });
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(initHeroScrambleAnimation, 200);
      });
    } else {
      setTimeout(initHeroScrambleAnimation, 200);
    }

    // Re-run when a hero section is reloaded in the theme editor
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('.hero__content-wrapper')) {
          setTimeout(initHeroScrambleAnimation, 100);
        }
      });
    }
  }

  waitForGSAP(init);
})();
